/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Import_Success_ToastInputs */



/**
* | output |
* | --- |
* | "Shortcuts imported successfully" |
*
* @param {Shortcut_Keys_Import_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_import_success_toast = /** @type {((inputs?: Shortcut_Keys_Import_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Import_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Raccourcis importes avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verknüpfungen erfolgreich importiert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Collegamenti importati correttamente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ярлыки успешно импортированы.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Accesos directos importados correctamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("快捷方式已成功导入")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ショートカットが正常にインポートされました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शॉर्टकट सफलतापूर्वक आयात हो गए।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atalhos importados com sucesso")
	return /** @type {LocalizedString} */ ("Shortcuts imported successfully")
});